import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { message, Icon } from 'antd';


Modal.setAppElement('#root')

@inject("web3Store")
@inject("contractStore")
@inject("ViewStore")
@observer(["web3Store", "contractStore", "ViewStore", "AuthStore", "AdminStore", "UserStore", "CustomRouter"])
class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            loading: false, // Loading button state
            errorScreen: false,
            errorMessage: "",
            secondsToGo: 5,
         
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    async componentDidMount() {
        const { contractStore } = this.props
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleSignup = publicAddress =>
        fetch((process.env.REACT_APP_BACKEND_URL + '/users'), {
            body: JSON.stringify({ publicAddress }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        }).then(response => response.json());

    handleAuthenticate = ({ publicAddress, signature }) =>
        //fetch(`${url}/auth`, {           
        fetch((process.env.REACT_APP_BACKEND_URL + '/auth'), {
            body: JSON.stringify({ publicAddress, signature }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        }).then(response => response.json());
    modalCloseCountDown() {
        setInterval(() => {
            this.setState({ secondsToGo: this.state.secondsToGo - 1 });
        }, 1000);
        setTimeout(() => this.closeModal(), this.state.secondsToGo * 1000);
    }
    handleClick = () => {
       

        const { web3Store, onLoggedIn, AdminStore } = this.props
        if (web3Store.status == "LOADED") {
        this.openModal();
        // Look if user with current publicAddress is already present on backend
        const publicAddress = web3Store.account.toLowerCase();
        console.log(publicAddress);
        this.setState({ loading: true });
        fetch(
            // `${
            // process.env.REACT_APP_BACKEND_URL
            // }/users?publicAddress=${web3Store.account}`
            //`http://localhost:8000/api/users?publicAddress=${publicAddress}`
            (process.env.REACT_APP_BACKEND_URL + '/users?publicAddress=' + publicAddress)
        )
            .then(response => response.json())
            // If yes, retrieve it. If no, create it.
            .then(
                users => (users !== null ? users : this.handleSignup(publicAddress))
            )
            // .then(
            //     users => this.checkUser(publicAddress)
            // )
            // Popup MetaMask confirmation modal to sign message
            .then(this.handleSignMessage)
            // Send signature to backend on the /auth route
            .then(this.handleAuthenticate)
            // Pass accessToken back to parent component (to save it in localStorage)

            .then(onLoggedIn)

            .catch(err => {
                //window.alert(err);
                let errorMsgReplace = err.message;
                let errorMsgReplaced = "Nonce not signed!";// errorMsgReplace.replace("Returned error: Error: MetaMask Message Signature: ", "");
                this.setState({ errorMessage: errorMsgReplaced });
                this.setState({ loading: false, errorScreen: true });
                this.modalCloseCountDown();
            });
        } else if (web3Store.status == "LOAD_ERROR") {
           AdminStore.actionAttemptedWithoutWeb3();          
        }
    }


    checkUser = (publicAddress) => {
        console.log(publicAddress);
        this.setState({ loading: true });
        fetch(
            // `${
            // process.env.REACT_APP_BACKEND_URL
            // }/users?publicAddress=${web3Store.account}`
            //`http://localhost:8000/api/users?publicAddress=${publicAddress}`
            (process.env.REACT_APP_BACKEND_URL + '/users?publicAddress=' + publicAddress)
        )
            .then(response => response.json())
            // If yes, retrieve it. If no, create it.
            .then(
                users => {
                    if (users !== null) {
                        console.log('Already Signed Up')
                    } else {
                        this.handleSignup(publicAddress)
                        console.log('Signed Up')
                    }
                }
            )
    }

    handleSignMessage = ({ publicAddress, nonce }) => {
        const { web3Store } = this.props
        //onsole.log(web3Store);
        return new Promise((resolve, reject) =>
            web3Store.web3.eth.personal.sign(
                web3Store.web3.utils.fromUtf8(`I am signing my one-time nonce: ${nonce}`),
                publicAddress,
                (err, signature) => {
                    if (err) return reject(err);
                    return resolve({ publicAddress, signature });
                }
            )
        );
    };

    render() {

        const { loading, errorScreen, errorMessage, secondsToGo } = this.state;
        let content = "";

        if (loading && !errorScreen) {
            content =
                <div className="login-modal-container">
                    <h1>LOGGING YOU IN...</h1>
                    <div className="login-animation">
                        <div style={{ position: 'relative' }}><img style={{ position: 'absolute', margin: '0px 0px 0px -42px', zIndex: '1001' }} src={require('../../assets/img/logoV.svg')} width="90px" /></div>
                        <ul className="loading-dots">
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                        <img style={{ margin: '0 -24px 0 0', zIndex: '1001' }} src={require('../../assets/img/metamask-logo.png')} width="95px" />
                    </div>
                </div>
        }
        if (!loading && errorScreen) {
            content = <div style={{ margin: '85px' }}>
                <div style={{ textAlign: 'center', color: '#ff0000', letterSpacing: '3px', fontSize: '24px' }}>LOGIN ERROR: {errorMessage}</div>
                <pre style={{ textAlign: 'center', marginTop: '70px' }}><Icon style={{ fontSize: '148px', color: '#ff0000' }} type="close" /></pre>
                <div style={{ textAlign: 'center', color: '#fff', marginTop: '30px', letterSpacing: '3px', fontSize: '12px' }}>Closing window in: {secondsToGo}</div>
            </div>
        }

        return (
            <div className="login-modal-component">
                <button className="custom-btn-primary" onClick={this.handleClick}><img src={require('../../assets/img/metamask-logo.png')} width="16px" style={{ margin: '0px 5px 3px 0px' }} /> Login</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Login Modal"
                    className="login-modal"
                    overlayClassName="login-modal-overlay"
                >
                    <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                    {content}
                </Modal>

            </div>
        );
    }
}

export default LoginModal;


// WEBPACK FOOTER //
// ./src/components/modals/LoginModal.js